import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import * as Template from "../../templates";

import * as actions from "../../actions";

import { useNavigate, useParams } from "react-router-dom";

export default () => {

  const moduleName = `faq_categories`;

  const appReducer = useSelector((state) => state.appReducer, shallowEqual);

  const dispatch = useDispatch();

  const params = useParams()

  const navigate = useNavigate()

  const [id, setId] = useState();

  const [state, setState] = useState(``);
  const [name, setName] = useState(``);
  const [image, setImage] = useState(``);

  const [submitted, setSubmitted] = useState(false);

  const handleChangeState = (value) => setState(value);
  const handleClick = () => {
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
    setSubmitted(true)
  };

  useEffect(() => {
    if (submitted) {
      if (
        (appReducer.faq_categories_store != undefined && appReducer.faq_categories_store.error == false) ||
        (appReducer.faq_categories_update != undefined && appReducer.faq_categories_update.error == false)
      ) {
        navigate(-1)
      }
    }
    return () => setSubmitted(false)
  }, [
    appReducer.faq_categories_store,
    appReducer.faq_categories_update
  ])

  useEffect(() => {
    if (appReducer.faq_categories_edit != undefined && id != undefined) {
      let row = appReducer.faq_categories_edit.data;
      setName(row.name);
      setId(row.id);
      setImage(row.image_full);
      setState({
        value: row.state,
        label: row.state == `active` ? `فعال` : `غیرفعال`,
      });
    }
  }, [appReducer.faq_categories_edit]);

  useEffect(() => {
    if (id != undefined) {
      dispatch(actions.edit(id, moduleName));
    }
  }, [id]);

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])
  
  return <Template.Form>
    <Template.Input required value={name} label="نام" name="name" type="text" />
    <Template.FileInput
      deleteUrl="faq_categories/destroy_image"
      rowId={id}
      className="image"
      value={image && [image]}
      name="image"
      label="آیکون"
    />
    <Template.SingleSelect
      withLabel
      required
      placeholder="وضعیت"
      onChange={handleChangeState}
      name="state"
      value={state}
      options={[
        {
          value: "active",
          label: "فعال",
        },
        {
          value: "deactive",
          label: "غیرفعال",
        },
      ]}
    />
    <Template.Button
      label="ذخیره"

      onClick={handleClick}
    />
  </Template.Form>
};